<template>
  <div class="icon-wrap" :class="iconStyle" @click="onClick">

  </div>
</template>

<script>
export default {
  name: 'icon',
  props: {
    iconStyle: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      clicked: false
    }
  },
  methods: {
    onClick (event) {
      if (!this.clicked) {
        this.clicked = true
        setTimeout(() => {
          this.clicked = false
        }, 500)
        if (this.disabled) {
          return
        }
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-wrap {
  width: 34px;
  height: 34px;
  border-radius: 20px;
  border: solid 1px #bbb;
  background: #fff;
  transition: 0.3s;
  cursor: pointer;
  &.plus {
    position: absolute;
    top: 1px;
    right: -5px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #bbb;
    background: #fff url('../../assets/images/icon-question-plus.svg') no-repeat center;
    &:hover {
      background: #f7f7f7 url('../../assets/images/icon-question-plus.svg') no-repeat center;
    }
  }
  &.del {
    position: absolute;
    top: 1px;
    right: 35px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #bbb;
    background: #fff url('../../assets/images/icon-question-del.svg') no-repeat center;
    &:hover {
      background: #f7f7f7 url('../../assets/images/icon-question-del.svg') no-repeat center;
    }
  }
}

</style>
